import useVirtualKeyboard from 'hooks/useVirtualKeyboard';
import React from 'react';

const withKeyboardFittingElement = (Component) => {
  const KeyboardFittingElementComponent = (props) => {
    const { ref: inputRef, KeyboardFittingElement } = useVirtualKeyboard();

    const newProps = {
      ...props,
      inputRef,
    };
    return (
      <>
        <Component {...newProps} />
        <KeyboardFittingElement />
      </>
    );
  };
  return KeyboardFittingElementComponent;
};

export default withKeyboardFittingElement;
